import { render } from "./parents.vue?vue&type=template&id=3c0bbce8"
import script from "./parents.vue?vue&type=script&lang=js"
export * from "./parents.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ruslan/Desktop/birch/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__